import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Global } from '../../shared/global';
import { EMPTY, Observable, from } from 'rxjs';
import { IOffertBaseVerificationResult } from '../models/offertbaseverificationresult';
import { switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MaintainanceService } from './maintainance.service';

@Injectable({
  providedIn: 'root'
})
export class OffertBaseService {

  constructor(private http: HttpClient, private router: Router, private maintainanceService: MaintainanceService) { }

  getOffertBase(query: string, _offertBaseId: number = null): Observable<IOffertBaseVerificationResult> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers };
    return from(this.maintainanceService.deploymentInProgess()).pipe(
      switchMap(deploymentInProgress => {
        if (deploymentInProgress) {
          this.router.navigate(['/maintenance']);
          return EMPTY;
        } else {
          return this.http.post<IOffertBaseVerificationResult>(Global.BASE_OFFERTBASE_ENDPOINT +
            `getoffertbase` + (query ? `?q=${query}` : ''), null, options);
        }
      }));
  }

}
